export default __webpack_public_path__ + "static/media/design.e5323b41.e5323b41.jpg";